import _isNumber from "lodash/isNumber";
import { getCostForState, getLoanToDownPayment, getMinDownPayment } from './helpers';
import getItemizedClosingCosts from './get-itemized-closing-costs';
import { RECOMMENDED_DOWN_PAYMENT_PERCENT } from '../data/constants';

// TODO document
export default function getFundsNeeded(_ref) {
  var annualInterestRate = _ref.annualInterestRate,
    shouldAddInsurance = _ref.shouldAddInsurance,
    loanAmount = _ref.loanAmount,
    loanType = _ref.loanType,
    monthlyHomeownersInsurance = _ref.monthlyHomeownersInsurance,
    state = _ref.state,
    veteranType = _ref.veteranType,
    firstVaLoan = _ref.firstVaLoan,
    yearlyPropertyTax = _ref.yearlyPropertyTax,
    outputDownPayment = _ref.outputDownPayment,
    downPaymentOverride = _ref.downPaymentOverride,
    fundsNeeded = _ref.fundsNeeded;
  var closingCosts = getItemizedClosingCosts(shouldAddInsurance, {
    annualInterestRate: annualInterestRate,
    loanAmount: loanAmount,
    loanType: loanType,
    monthlyHomeownersInsurance: monthlyHomeownersInsurance,
    veteranType: veteranType,
    firstVaLoan: firstVaLoan,
    yearlyPropertyTax: yearlyPropertyTax,
    state: state,
    outputDownPayment: outputDownPayment,
    originationCharges: getCostForState(state, 'originationCharges'),
    appraisalFee: getCostForState(state, 'appraisalFee'),
    stateTransferTax: getCostForState(state, 'stateTransferTax')
  });
  var downPayment;
  if (_isNumber(fundsNeeded)) {
    downPayment = fundsNeeded - closingCosts.total;
  } else {
    downPayment = _isNumber(downPaymentOverride) ? downPaymentOverride : loanAmount * getLoanToDownPayment(RECOMMENDED_DOWN_PAYMENT_PERCENT);

    // FIXME at parity with current logic, but this probably should only be applied if we don't have an override
    downPayment -= closingCosts.upfrontMortgageInsurance;
  }
  return {
    downPayment: Math.max(downPayment, getMinDownPayment({
      loanAmount: loanAmount,
      loanType: loanType
    })),
    fundsNeeded: downPayment + closingCosts,
    closingCosts: closingCosts
  };
}